import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Questions from './pages/Questions';
import Consent from './pages/Consent';
import BarcodeScanner from './pages/BarcodeScanner';
import BarcodeDetails from './pages/BarcodeDetails';
import Welcome from './pages/Welcome';
import BarcodePDF417Scanner from './pages/BarcodePDF417Scanner';

function App() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f0f5',
      paddingBottom: '50px'
    }}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/consent" element={<Consent />} />
        <Route path="/barcode-scanner" element={<BarcodeScanner />} />
        <Route path="/barcode-details" element={<BarcodeDetails />} />
        <Route path="/barcode-pdf417-scanner" element={<BarcodePDF417Scanner />} />
      </Routes>
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#333333',
        color: 'white',
        textAlign: 'center',
        padding: '10px 0',
        fontSize: '14px',
        fontFamily: "'Arial', sans-serif",
        borderTop: '1px solid #ddd',
        zIndex: 1000
      }}>
        © ARL Aviation Services 2025. All Rights Reserved.
      </footer>
    </div>
  );
}

export default App;
